export const VITE_TOS_URL = import.meta.env.VITE_TOS_URL;
export const VITE_POLICY_URL = import.meta.env.VITE_POLICY_URL;
export const VITE_API_URL = import.meta.env.VITE_API_URL;
export const VITE_BRIDGE_URL = import.meta.env.VITE_BRIDGE_URL;
export const VITE_CONNECT_CALLBACK_URL = import.meta.env
  .VITE_CONNECT_CALLBACK_URL;
export const MODE = import.meta.env.MODE;
export const PROD = import.meta.env.PROD;

export const PALM_LEFT = 0;
export const PALM_RIGHT = 1;
export const PALM_BOTH = -1;
